const DEFAULT_BREAKPOINT = 768

function initSingleTable(table, breakpoint) {
    const tbody = table.querySelector('tbody')

    if (!tbody) return

    const originalRows = Array.from(tbody.querySelectorAll('tr'))
    let isMobile = null
    let resizeTimeout = null

    function buildMobile() {
        const fragment = document.createDocumentFragment()

        originalRows.forEach((row) => {
            const tds = Array.from(row.querySelectorAll('td'))
            const td1 = tds[0]
            const td2 = tds[1]
            const td3 = tds[2]

            const row1 = document.createElement('tr')
            row1.appendChild(td1.cloneNode(true))
            if (td2) row1.appendChild(td2.cloneNode(true))
            fragment.appendChild(row1)

            if (td3 && td3.textContent.trim()) {
                const row2 = document.createElement('tr')
                row2.appendChild(td1.cloneNode(true))
                row2.appendChild(td3.cloneNode(true))
                fragment.appendChild(row2)
            }
        })

        tbody.innerHTML = ''
        tbody.appendChild(fragment)
    }

    function restoreDesktop() {
        tbody.innerHTML = ''
        originalRows.forEach((row) => {
            tbody.appendChild(row.cloneNode(true))
        })
    }

    function updateLayout() {
        const shouldBeMobile = window.innerWidth < breakpoint

        if (shouldBeMobile === isMobile) return

        isMobile = shouldBeMobile

        if (isMobile) {
            buildMobile()
        } else {
            restoreDesktop()
        }
    }

    function onResize() {
        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(updateLayout, 150)
    }

    updateLayout()
    window.addEventListener('resize', onResize)
}

export function initTableResponsive({
    selector = '.render-context-program',
    breakpoint = DEFAULT_BREAKPOINT,
} = {}) {
    document.querySelectorAll(selector).forEach((table) => {
        initSingleTable(table, breakpoint)
    })
}
